import ChatSignInState from '../../store/schema/ChatSignInState';
import getSkypeApi from './getSkypeApi';
import getShouldAutoSignIn from '../services/getShouldAutoSignIn';
import setShouldAutoSignIn from '../services/setShouldAutoSignIn';
import mountSkypeIfNeed from '../components/UcwaChatView';
import onUcwaNotification from './onUcwaNotification';
import { changeSignInState } from '../../actions/presenceActions';
import { onMyPresenceChanged } from '../presenceManager/subscribePresence';
import { setUnreadCount } from '../actions/ucwaActions';

export default function signInIM(isUserExplicitSignIn: boolean) {
    getSkypeApi(true /*reinit*/).then(async api => {
        api.me.authenticated.subscribe(onAuthenticatedChanged);
        api.me.status.subscribe(onMyPresenceChanged);
        api.activity.unreadConversations.subscribe(setUnreadCount);
        api.setNotificationHandler(onUcwaNotification);
        api.setAuthProvider({ type: 'implicitOAuth' }, false /*isAuthTypeProvided*/);

        if (await shouldSignIn(isUserExplicitSignIn)) {
            api.signIn(onSuccess);

            if (isUserExplicitSignIn) {
                setShouldAutoSignIn(true /*shouldAutoSignIn*/);
            }
        }
    });
}

function onSuccess() {
    mountSkypeIfNeed(true /*forceRemount*/);
}

async function shouldSignIn(isUserExplicitSignIn: boolean) {
    return isUserExplicitSignIn || getShouldAutoSignIn();
}

function onAuthenticatedChanged(authenticated: boolean) {
    changeSignInState(authenticated ? ChatSignInState.SignedIn : ChatSignInState.SignedOut);
}
